import {
  AgeGroup,
  Gender,
  IAutocompleteOption,
  ICoordinatesFiler,
  IPolygonFilter,
  Month,
  Race,
  WeekDay,
} from './filter.models';

export enum DateTimePreset {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  LAST_3_DAYS = 'last3Days',
  LAST_WEEK = 'lastWeek',
}

export enum TimeframePreset {
  LAST_2_WEEKS = 'last2Weeks',
  LAST_28_DAYS = 'last28Days',
  LAST_MONTH = 'lastMonth',
  LAST_3_MOMTHS = 'last3Months',
  LAST_6_MONTHS = 'last6Months',
  LAST_YEAR = 'lastYear',
}

export interface IAreaGroup {
  cities?: IAutocompleteOption[];
  zipCodes?: IAutocompleteOption[];
  departmentId?: string;
}

export interface IDemographicsGroup {
  races?: Race[];
  gender?: Gender;
  ageGroup?: AgeGroup;
}

export interface IDateTimeGroup {
  daysOfWeek?: WeekDay[];
  months?: Month[];
}

export interface ICitationDatesGroup {
  fromDate?: Date | string;
  toDate?: Date | string;
}

export interface ITimeGroup {
  hoursFrom?: string;
  minutesFrom?: string;
  hoursTo?: string;
  minutesTo?: string;
}

export interface IVehiclesGroup {
  colors?: IAutocompleteOption[];
  makes?: IAutocompleteOption[];
  models?: IAutocompleteOption[];
  types?: IAutocompleteOption[];
  licensePlate?: string;
  state?: string;
  releaseDateFrom?: Date | string;
  releaseDateTo?: Date | string;
}

export interface IStopDetailsGroup {
  reasonForStop?: string[];
  reasonForSearch?: string[];
  contrabandOrEvidence?: string[];
  resultOfStop?: string[];
}

export interface IPersonnelGroup {
  departmentId?: string;
  officers?: IAutocompleteOption[];
  units?: IAutocompleteOption[];
}

export interface IPersonalGroup {
  officer?: {
    id?: string;
    value?: string;
  };
}

export interface IFiltersForm {
  citationDateGroup?: ICitationDatesGroup;
  dateTimeGroup?: IDateTimeGroup;
  timeGroup?: ITimeGroup;
  areaGroup?: IAreaGroup;
  vehiclesGroup?: IVehiclesGroup;
  demographicsGroup?: IDemographicsGroup;
  offenceDescGroup?: Record<string, boolean>;
  stopDetailsGroup?: IStopDetailsGroup;
  personalGroup?: IPersonalGroup;
  personnelGroup?: IPersonnelGroup;
  coordinatesFilter?: ICoordinatesFiler;
  polygonFilter?: IPolygonFilter;
}

export interface ISelectOption<T = string> {
  value: T;
  viewValue: string;
}
